import { useMutation } from 'react-query';

import { GenerateTemplateFromMessageResponseDto } from '../../../../backend/src/prompt-template/dto/generate-template-from-message.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface GenerateTemplateFromMessageParameters {
  messageId: string;
}

export const useGenerateTemplateFromMessage = (matterId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<GenerateTemplateFromMessageResponseDto, Error, GenerateTemplateFromMessageParameters>(
    async ({ messageId }) => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.POST });

      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/prompt-template/from-message/${messageId}`,
        fetchConfig,
      );

      if (!res.ok) {
        const errorBody = await res.json().catch(() => null);
        const message =
          (Array.isArray(errorBody?.message) ? errorBody.message[0] : errorBody?.message) ??
          'Generating template from answer failed';
        throw new Error(message);
      }
      return res.json();
    },
  );
};
